
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loading, session } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log('=== PROTECTED ROUTE CHECK ===');
    console.log('Loading:', loading);
    console.log('User:', user?.email);
    console.log('Session exists:', !!session);
    console.log('Session access_token:', !!session?.access_token);
    console.log('Session expires at:', session?.expires_at);
    console.log('Current path:', location.pathname);

    // Don't redirect during loading
    if (loading) {
      console.log('Still loading, waiting...');
      return;
    }
    
    // Check if session is expired
    const isSessionExpired = session?.expires_at ? 
      new Date(session.expires_at * 1000) < new Date() : false;
    
    console.log('Session expired?', isSessionExpired);
    
    // If no user, no session, or session is expired, redirect to signin
    if (!user || !session || !session.access_token || isSessionExpired) {
      console.log('No valid session, redirecting to signin');
      console.log('Redirect reason:', {
        noUser: !user,
        noSession: !session,
        noAccessToken: !session?.access_token,
        expired: isSessionExpired
      });
      
      const redirectPath = location.pathname !== '/signin' ? location.pathname : '/dashboard';
      navigate('/signin', { 
        state: { redirectTo: redirectPath },
        replace: true 
      });
    }
  }, [user, loading, session, navigate, location.pathname]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Check if session is expired
  const isSessionExpired = session?.expires_at ? 
    new Date(session.expires_at * 1000) < new Date() : false;

  // Only render children if we have a valid user, session, and it's not expired
  if (!user || !session || !session.access_token || isSessionExpired) {
    return null;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
